import { render, staticRenderFns } from "./MomentActivityFeedComponent.vue?vue&type=template&id=1b9938e9&scoped=true&"
import script from "./MomentActivityFeedComponent.vue?vue&type=script&lang=ts&"
export * from "./MomentActivityFeedComponent.vue?vue&type=script&lang=ts&"
import style0 from "./MomentActivityFeedComponent.vue?vue&type=style&index=0&id=1b9938e9&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b9938e9",
  null
  
)

export default component.exports